import { gridKeikka_copyJSON } from "src/pages/Grid/GridKeikka/gridKeikkaFunctions";

export function emitSocket(socket, ev, data) {
  socket.emit(ev, data);
}

// socket.emit("onSave", {
//   type: "palkki",
//   action: "copy",
//   palkkiId: this.palkkiId,
//   keikkaId: null,
//   ownerAsiakasId: this.ownerAsiakasId,
//   yyyymmdd: getYYYYMMDD(this.timeStart),
//   keikkaData: null,
//   gridKeikka: null,
//   palkkiData: null,
// });

// type:  gridKeikka, keikkaData, keikkaTila
// action: save

// type:betoni action:delete / copy / switch
// type: gridKeikka action: save / copy
// type: keikka action: removePerson

export class socketOnSave {
  constructor(personId, socket, ownerAsiakasId, type, action, keikkaOrPalkkiId) {
    this.roomId = keikkaOrPalkkiId;
    this.personId = personId;
    this.socket = socket;
    this.type = type; // palkki, gridKeikka, keikka
    this.action = action; // copy, save, delete
    this.keikkaId = keikkaOrPalkkiId;
    this.ownerAsiakasId = ownerAsiakasId;
    this.yyyymmdd = null;
    this.keikkaData = {};
    this.gridKeikka = {};
    this.gridPalkki = {};
    this.betoniData = {};
    this.keikka = {};
  }

  emitSave = () => {
    if (!this.socket) {
      console.error("socketOnSave.emitSave: socket is null");
      return;
    }
    if (this.keikkaData?.keikkaId > 0) this.roomId = this.keikkaData.keikkaId;
    else if (this.gridKeikka?.keikkaId > 0) this.roomId = this.gridKeikka.keikkaId;
    else if (this.gridPalkki?.palkkiId > 0) this.roomId = "p" + this.gridPalkki.palkkiId;
    else if (this.keikka?.keikkaId > 0) this.roomId = this.keikka.keikkaId;
    console.log("socketOnSave.emitSave", this);
    this.socket.emit("onSave", gridKeikka_copyJSON(this));
  };
}
